import React, { Component } from 'react';
import { Link } from '~/UI/Button';

import styles from './default.less';

interface Props {
	to: string | null;
	children: string;
}

export default class BreadcrumbsItem extends Component<Props> {
	static defaultProps = {
		to: null,
		children: null,
	};

	render() {
		const { to, children } = this.props;

		return (
			<li className={styles.listItem} title={children}>
				{to !== null ? (
					<Link styles={{ button: styles.link }} to={to}>
						{children}
					</Link>
				) : (
					<strong className={styles.listItemContent}>{children}</strong>
				)}
			</li>
		);
	}
}
